import { Category } from './category';
import { Brand } from './brand.model';
import { PaginationFilters } from './paginationFilters';
import { StyleGroup } from './style-group';
import { Collection } from './collection';
import { Color, Gender, Style } from './style';
import { ExportChannel } from './export-channel';
import { Shot } from './shot';

export class ExportTemplate {
	id?: number;
	categoryId?: number;
	isDefault?: boolean;
	active?: boolean;
	brand?: Brand;
	category?: Category;
	collection?: Collection;
	gender?: Gender;
	styleGroup?: StyleGroup;
	styles?: Style[];
	colors?: Color[];
	exportChannel?: ExportChannel;
	shots?: Shot[];

	constructor(init?: Partial<ExportTemplate>) {
		Object.assign(this, init);
	}
}

export class ExportTemplateFilters extends PaginationFilters {
	brands?: Brand[];
	categories?: Category[];
	styleGroups?: StyleGroup[];
	exportChannelId?: number;

	constructor(init?: Partial<ExportTemplateFilters>) {
		super(init);
		Object.assign(this, init);
	}
}
